import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";

const researchAreas = [
  {
    title: "Solid-State Batteries",
    body: "We are developing batteries that replace liquid electrolytes with solid materials, aiming to double energy density while making batteries non-flammable and safer for vehicles and homes.",
  },
  {
    title: "Sodium-Ion Chemistry",
    body: "To reduce dependence on expensive raw materials like lithium and cobalt, we are pioneering Sodium-Ion technology — a sustainable, low-cost alternative perfect for large-scale grid storage.",
  },
  {
    title: "Ultra-Fast Charging",
    body: "Our team is investigating new electrode structures that allow batteries to charge in minutes rather than hours without degrading their lifespan.",
  },
  {
    title: "Long-Duration Storage",
    body: "We are researching solutions such as Iron-Air and Flow batteries, designed to store renewable energy for days or weeks to keep the grid stable during long periods of low sun or wind.",
  },
];

const Battery: React.FC = () => {
  return (
    <Container maxWidth="md" style={{ marginTop: "50px", marginBottom: "80px", fontFamily: "Roboto, sans-serif", padding: "20px" }}>
      <Typography variant="h4" style={{ fontWeight: "bold", marginBottom: "8px" }}>
        Battery Technology &amp; Energy Storage
      </Typography>
      <Typography variant="body1" style={{ color: "#555", marginBottom: "40px", lineHeight: 1.8 }}>
        The future of renewable energy and electric mobility depends on one thing: the ability to store power efficiently.
        Our research is focused on breaking the performance barriers of traditional lithium-ion batteries to create safer,
        cheaper, and more powerful energy storage solutions.
      </Typography>

      <Divider style={{ marginBottom: "40px" }} />

      <Typography variant="h5" style={{ fontWeight: "bold", marginBottom: "24px" }}>
        What We're Researching
      </Typography>

      {researchAreas.map((item, i) => (
        <Box key={i} style={{ marginBottom: "28px" }}>
          <Typography variant="h6" style={{ fontWeight: "bold", marginBottom: "8px" }}>
            {item.title}
          </Typography>
          <Typography variant="body1" style={{ color: "#555", lineHeight: 1.8 }}>
            {item.body}
          </Typography>
        </Box>
      ))}

      <Divider style={{ margin: "40px 0" }} />

      <Typography variant="h5" style={{ fontWeight: "bold", marginBottom: "16px" }}>
        Our Edge
      </Typography>
      <Typography variant="body1" style={{ color: "#555", lineHeight: 1.8 }}>
        We use <strong>AI-accelerated material discovery</strong> to simulate thousands of chemical combinations in seconds,
        moving the most promising battery chemistries into production faster than traditional research methods allow.
      </Typography>
    </Container>
  );
};

export default Battery;
